// src/data/journeyBooks.js
// Dữ liệu các cuốn sách kỷ niệm & hành trình du lịch của Huy Hanh & Linh Phương

export const journeyBooks = [
  {
    id: "book-first-trip",
    category: "travel",
    title: "Chuyến Đi Đầu Tiên",
    spineTitle: "Chuyến Đi Đầu Tiên",
    subtitle: "Đà Lạt Mộng Mơ • 2025",
    year: "2025",
    spineColor: "linear-gradient(180deg, #2d5a4c 0%, #1e3f35 100%)",
    accentColor: "#4e8c75",
    icon: "🌲",
    badge: "Chuyến đi",
    location: "Đà Lạt, Lâm Đồng",
    dateRange: "15.01.2025 — 18.01.2025",
    blogText: `Chuyến đi xa đầu tiên của hai đứa sau khi chính thức quen nhau. Đà Lạt trời lạnh căm nhưng có người vừa đi vừa than đói, vừa chụp cho cả trăm kiểu ảnh vô tri. 
    Những buổi sáng sớm dậy săn mây, những ly cà phê ấm nóng và cảm giác lần đầu tiên nhận ra: đi đâu cũng được, miễn là đi cùng nhau!`,
    photos: [
      {
        url: "https://lh3.googleusercontent.com/d/1ZWaCpsdpBads-J1h6E6IcWfUBEt24dbd",
        caption: "Buổi sáng se lạnh tại quán cà phê trên đồi ☕",
        date: "16.01.2025",
        rotate: "-2deg"
      },
      {
        url: "https://lh3.googleusercontent.com/d/1p4GLu7q4dmIkrg99q4PVFhHL0HcgJ9QO",
        caption: "Lúc này bảo tạo dáng ngầu ai ngờ cười tít mắt",
        date: "16.01.2025",
        rotate: "3deg"
      },
      {
        url: "https://lh3.googleusercontent.com/d/1McFnjw1-yLjZClrFGANHrKmUymLZuhRu",
        caption: "Góc phố quen thuộc, lưu giữ nụ cười hạnh phúc",
        date: "17.01.2025",
        rotate: "-1deg"
      }
    ]
  },
  {
    id: "book-proposal",
    category: "milestone",
    title: "Dạm Ngõ & Cầu Hôn",
    spineTitle: "Dạm Ngõ & Cầu Hôn",
    subtitle: "10 Vòng Vinhomes • 26.06.2025",
    year: "2025",
    spineColor: "linear-gradient(180deg, #7c3a4d 0%, #542231 100%)",
    accentColor: "#b85d75",
    icon: "💍",
    badge: "Cột mốc",
    location: "Vinhomes Grand Park, TP.HCM",
    dateRange: "26.06.2025",
    blogText: `Ngày 26.06.2025 vừa là ngày dạm ngõ, vừa là ngày sinh nhật của Hanh và cũng là ngày cầu hôn định mệnh!
    Hôm đó Hanh hồi hộp đến mức dắt Phương đi lòng vòng hết đúng 10 vòng Vinhomes để chờ thời cơ thích hợp. Cuối cùng chiếc nhẫn cũng được trao tận tay và lời đồng ý trăm năm được cất lên trong niềm hạnh phúc nghẹn ngào.`,
    photos: [
      {
        url: "https://lh3.googleusercontent.com/d/1ibFAGGHAXVXckgMGDuiSVyNb2YG-hDgE",
        caption: "Sau 10 vòng Vinhomes cuối cùng chiếc nhẫn đã vào tay nàng 💍",
        date: "26.06.2025",
        rotate: "2deg"
      },
      {
        url: "https://lh3.googleusercontent.com/d/1Nn-QI97Pc97icMZvrpZGze_j_ycBDCMz",
        caption: "Ngày đi đăng ký kết hôn: Chính thức chốt sổ!",
        date: "10.11.2025",
        rotate: "-3deg"
      },
      {
        url: "https://lh3.googleusercontent.com/d/13AIzHX2KJJURR_2BzpkwoMkgqLx9-Dfy",
        caption: "Buổi duyệt ảnh cưới chuẩn bị cho ngày trọng đại",
        date: "12.12.2025",
        rotate: "1.5deg"
      }
    ]
  },
  {
    id: "book-the-wedding",
    category: "milestone",
    title: "Ngày Chung Đôi — The Big Day",
    spineTitle: "Ngày Chung Đôi",
    subtitle: "Hôn Lễ Trọng Đại • 26.02.2026",
    year: "2026",
    spineColor: "linear-gradient(180deg, #1b3858 0%, #102338 100%)",
    accentColor: "#e5c378",
    icon: "👰🤵",
    badge: "Cột mốc",
    location: "Tây Ninh & Đồng Nai",
    dateRange: "26.02.2026",
    blogText: `Khoảnh khắc bước đi trên lễ đường trong sự chúc phúc của gia đình, bạn bè và những người thân yêu nhất.
    Bộ váy cưới lộng lẫy của Phương, nụ cười hạnh phúc của Hanh và những giọt nước mắt xúc động của ba mẹ hai bên. Một ngày hoàn hảo mở ra một gia đình trọn vẹn!`,
    photos: [
      {
        url: "https://lh3.googleusercontent.com/d/1eF9GN4B0vhv1S_p3CvVcTtQX1q4obJ-r",
        caption: "Khoảnh khắc thiêng liêng nhất khi hai đứa chính thức là vợ chồng 💕",
        date: "26.02.2026",
        rotate: "-2deg"
      },
      {
        url: "https://lh3.googleusercontent.com/d/16VM30OxNhVyf5r1OmA99bvtEyDF5wSNj",
        caption: "Nụ cười rạng rỡ của cô dâu chú rể trong ngày cưới",
        date: "26.02.2026",
        rotate: "2.5deg"
      },
      {
        url: "https://lh3.googleusercontent.com/d/1lO2q0lx3UqWxgxuIgPZw9zrJhOEQIkWE",
        caption: "Tay trong tay hướng về tương lai phía trước",
        date: "26.02.2026",
        rotate: "-1.5deg"
      },
      {
        url: "https://lh3.googleusercontent.com/d/1xtiiof4u9_7YYtFhGpDcWfktqoFjn7zr",
        caption: "Khoảnh khắc ngọt ngào ghi dấu tình yêu vĩnh cửu",
        date: "26.02.2026",
        rotate: "2deg"
      }
    ]
  },
  {
    id: "book-honeymoon",
    category: "travel",
    title: "Tuần Trăng Mật & Biển Xanh",
    spineTitle: "Tuần Trăng Mật",
    subtitle: "Chuyến Phiêu Lưu Mới • 2026",
    year: "2026",
    spineColor: "linear-gradient(180deg, #9c6644 0%, #683b24 100%)",
    accentColor: "#dd9f74",
    icon: "🌊",
    badge: "Chuyến đi",
    location: "Phú Quốc — Đảo Ngọc",
    dateRange: "Tháng 03.2026",
    blogText: `Sau bao ngày chuẩn bị cưới tất bật, đây là lúc hai vợ chồng cùng tự thưởng cho mình một kỳ nghỉ trọn vẹn bên bờ biển. 
    Ngắm hoàng hôn tím buông xuống mặt biển, thưởng thức hải sản và lên kế hoạch cho những mục tiêu lớn của tổ ấm nhỏ.`,
    photos: [
      {
        url: "https://lh3.googleusercontent.com/d/10IHj_b2A39dm3pqvXewP_xkBK1f_ZGoq",
        caption: "Hoàng hôn trên biển tuyệt đẹp bên người thương",
        date: "03.2026",
        rotate: "1deg"
      },
      {
        url: "https://lh3.googleusercontent.com/d/1p1QqtOf6H1QIUkLYLGnhXCvpo3g8Ehwz",
        caption: "Những bước chân thảnh thơi trên bờ cát trắng",
        date: "03.2026",
        rotate: "-2.5deg"
      },
      {
        url: "https://lh3.googleusercontent.com/d/1nvVg6eYr6mshwRzDZUK3qMTgJAUSpWsz",
        caption: "Cùng nhau ghi lại từng khoảnh khắc đáng yêu",
        date: "03.2026",
        rotate: "2deg"
      }
    ]
  },
  {
    id: "book-daily-life",
    category: "daily",
    title: "Góc Nhỏ Hằng Ngày",
    spineTitle: "Góc Nhỏ Hằng Ngày",
    subtitle: "Hôn Nhân & Những Mẩu Chuyện Vui",
    year: "2026+",
    spineColor: "linear-gradient(180deg, #435b66 0%, #2b3d45 100%)",
    accentColor: "#82a1b1",
    icon: "🏡",
    badge: "Đang viết tiếp",
    location: "Tổ Ấm Của Hanh & Phương",
    dateRange: "Mỗi ngày",
    blogText: `Cuộc sống sau đám cưới không cần phải lúc nào cũng rộn ràng, chỉ cần mỗi buổi tối cùng nhau nấu ăn, chia sẻ những câu chuyện công việc và cùng nhau cười vì những trò đùa ngớ ngẩn. 
    Tập sách này sẽ còn được hai đứa viết tiếp mãi mãi về sau!`,
    photos: [
      {
        url: "https://lh3.googleusercontent.com/d/1XBTNGiiojvrbMoGO4vHIAHNDMlx41lq7",
        caption: "Góc nhỏ ấm áp và những bữa ăn cùng nhau 🍲",
        date: "Mỗi ngày",
        rotate: "-1.5deg"
      },
      {
        url: "https://lh3.googleusercontent.com/d/1q9rbBeBfLDxh6CUbYAL_X1ogcjObissS",
        caption: "Nụ cười bình yên bên nhau sau một ngày dài",
        date: "Mỗi ngày",
        rotate: "2deg"
      }
    ]
  }
];
